import { render, staticRenderFns } from "./egame.vue?vue&type=template&id=1edb8235&scoped=true&"
import script from "./egame.vue?vue&type=script&lang=js&"
export * from "./egame.vue?vue&type=script&lang=js&"
import style0 from "./egame.vue?vue&type=style&index=0&id=1edb8235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb8235",
  null
  
)

export default component.exports